<template>
  <header class="header-bg" :class="is_sticky?'is_sticky':''">
    <div class="container">
      <div class="d-flex align-items-center flex-wrap flex-md-nowrap">
        <!-- <router-link :to="{name: 'homepage-index'}" v-if="homelink" class="logo"></router-link> -->
        <logo />
        <!-- <div class="logo" v-else></div> -->
        <div
          class="flag"
          v-if="show_language_items"
          :class="locale + '-flag-indicator'"
          @click="show_language_selector = !show_language_selector"
        >
          <div class="flag-dd" v-if="show_language_selector">
            <div class="dropdown-menu dropdown-with-icons show">
              <a href="/en" class="dropdown-item en-flag"></a
              ><a href="/ru" class="dropdown-item ru-flag"></a
              ><a href="/cn" class="dropdown-item cn-flag d-none"></a>
            </div>
          </div>
        </div>

        <nav class="navbar navbar-expand-lg ml-auto p-0 w-100" v-if="show_menu_items">
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item">
                <router-link
                  :to="{ name: 'comply-advantage-index' }"
                  class="nav-link"
                  >{{ $t("message.menu.monitoring") }}</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'find-partner-info' }"
                  class="nav-link"
                  >{{ $t("message.menu.find_partner") }}</router-link
                >
              </li>
              <li class="nav-item">
                <router-link :to="{ name: 'business-note' }" class="nav-link">
                  {{ $t("message.menu.business_note") }}</router-link
                >
              </li>
              <!-- <li class="nav-item">
                                    <router-link :to="{name: 'contracts-index'}" class="nav-link">Контракты</router-link>
                                </li>
                                <li class="nav-item">
                                    <router-link :to="{name: 'deals-index'}" class="nav-link">Сделки</router-link>
                                </li> -->
              <li class="nav-item">
                <router-link
                  v-if="is_authed"
                  :to="{ name: 'education-index' }"
                  class="nav-link"
                  >{{ $t("message.menu.education") }}</router-link
                >
                <router-link
                  v-else
                  :to="{ name: 'education-guest' }"
                  class="nav-link"
                  >{{ $t("message.menu.education") }}</router-link
                >
              </li>
              <li class="nav-item login">
                <router-link
                  :to="{ name: 'sign-in' }"
                  class="nav-link text-primary"
                  >{{ $t("message.menu.signin") }}</router-link
                >
              </li>
              <li class="nav-item register">
                <router-link
                  :to="{ name: 'sign-up' }"
                  class="nav-link text-white btn btn-pill btn-primary"
                  >{{ $t("message.menu.register") }}</router-link
                >
              </li>
            </ul>
          </div>
        </nav>
        <button
          class="navbar-toggler position-absolute right-20 top-20 d-block d-md-none"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i class="fa fa-bars"></i>
        </button>

        <div class="collapse navbar-collapse"></div>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  props: {
    show_language_selector: {
      type: Boolean,
    },
    show_language_items: {
      type: Boolean,
      default: true
    },
    show_menu_items: {
      type: Boolean,
      default: true
    },
    locale: {
      type: String,
    },
    homelink: {
      type: Boolean,
      default: false,
    },
    is_sticky: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    is_authed() {
      return this.$store.state.auth;
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");
</style>
<style scoped>
:root {
  font-family: "Roboto", sans-serif;
}
header {
  /* primary100 */
  padding: 20px 0;
  background: #ffffff;
  box-shadow: 0px 4px 60px rgba(0, 38, 66, 0.1);
  position: relative;
  z-index: 2;
}
.container {
  max-width: 1220px;
}
/* header .logo{
	    width: 127px;
        height: 32px;
        background-image: url("data:image/svg+xml,%3Csvg width='127' height='32' viewBox='0 0 127 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.8967 0.010939L20.1256 2.85504V18.3869L13.8967 21.8816V0.010939ZM11.4421 24.2637V32L0.44433 26.0763L0 18.0909L11.4421 24.2637ZM11.3729 14.1568V21.9877L0.44433 15.7571V8.1739L11.3729 14.1568ZM24.6844 25.9572L13.8269 31.881V24.2038L24.6844 18.1849V25.9572ZM11.3018 11.859L4.383 8.30516L4.7099 3.02105L11.3018 0V11.859Z' fill='%2304416D'/%3E%3Cpath d='M126.957 12.2588H122.689C122.611 11.7067 122.452 11.2163 122.212 10.7875C121.972 10.3523 121.663 9.9821 121.286 9.67681C120.91 9.37151 120.474 9.13767 119.981 8.97529C119.494 8.8129 118.964 8.7317 118.393 8.7317C117.36 8.7317 116.46 8.98828 115.694 9.50142C114.927 10.0081 114.333 10.7486 113.911 11.7229C113.488 12.6907 113.277 13.8664 113.277 15.25C113.277 16.6725 113.488 17.8677 113.911 18.8356C114.339 19.8034 114.937 20.5341 115.703 21.0278C116.47 21.5215 117.357 21.7683 118.363 21.7683C118.928 21.7683 119.451 21.6936 119.932 21.5442C120.419 21.3948 120.851 21.1772 121.228 20.8914C121.605 20.5991 121.916 20.2451 122.163 19.8294C122.417 19.4137 122.592 18.9395 122.689 18.4068L126.957 18.4263C126.847 19.3422 126.57 20.2256 126.129 21.0765C125.694 21.9209 125.106 22.6777 124.365 23.3467C123.631 24.0093 122.754 24.5354 121.735 24.9251C120.721 25.3084 119.575 25.5 118.295 25.5C116.515 25.5 114.924 25.0973 113.521 24.2918C112.124 23.4864 111.02 22.3204 110.208 20.794C109.403 19.2675 109 17.4195 109 15.25C109 13.074 109.409 11.2227 110.228 9.69629C111.046 8.16983 112.157 7.00713 113.56 6.20818C114.963 5.40273 116.541 5 118.295 5C119.451 5 120.523 5.16239 121.51 5.48717C122.504 5.81195 123.384 6.28612 124.151 6.9097C124.917 7.52677 125.541 8.28351 126.022 9.1799C126.509 10.0763 126.821 11.1026 126.957 12.2588Z' fill='%2304416D'/%3E%3Cpath d='M64.4479 9.71641H70.3689V6H53.9469V9.71641H59.7297V26H64.4479V9.71641Z' fill='%2304416D'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M42.2784 22.26H48.801L49.946 25.9994H55.1039L47.7716 6.00064H43.2965L36.0339 25.9994H41.1221L42.2784 22.26ZM43.4235 18.5436H47.6561L45.5282 11.6036L43.4235 18.5436Z' fill='%2304416D'/%3E%3Cpath d='M88.0972 9.71641H82.1763V26H77.4235V9.71641H71.6408V6H88.0972V9.71641Z' fill='%2304416D'/%3E%3Cpath d='M90 6H94.2188V18.5781H94.3848L103.027 6H106.729V26H102.5V13.4121H102.354L93.6621 26H90V6Z' fill='%2304416D'/%3E%3C/svg%3E");
        background-size: contain;
        background-repeat: no-repeat;
    } */
header .flag {
  background-image: url("data:image/svg+xml,%3Csvg width='36' height='32' viewBox='0 0 36 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cmask id='mask0_353_12184' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='6' y='6' width='24' height='20'%3E%3Crect x='6' y='6' width='24' height='20' rx='4' fill='%23D9D9D9'/%3E%3C/mask%3E%3Cg mask='url(%23mask0_353_12184)'%3E%3Crect x='6' y='19.333' width='24' height='6.66667' fill='%23D80027'/%3E%3Crect x='6' y='12.667' width='24' height='6.66667' fill='%230052B4'/%3E%3Crect x='6' y='6' width='24' height='6.66667' fill='%23F0F0F0'/%3E%3C/g%3E%3C/svg%3E");
  width: 36px;
  height: 32px;
  margin-left: 10px;
  background-repeat: no-repeat;
  background-size: contain;
}
header .nav-link {
  color: #797980;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}
.text-primary {
  color: var(--color1) !important;
}
.btn-primary {
  background: linear-gradient(90deg, var(--color1) 0%, var(--color2) 100%) !important;
  border: 0 !important;
}
body {
  background-color: #f9fafa !important;
}
article {
  background-color: #f9fafa !important;
  padding-bottom: 60px;
}
.hero {
  height: 514px;
  height: 33.5vw;
  background-color: #f9fafa;
  background-position: top right;
  background-repeat: no-repeat;
  background-size: contain;
  background-size: 50vw;
  background-image: url("./img_bridge_2.png");
  /* background: linear-gradient(90deg, #F9FAFA 1.42%, rgba(249, 250, 250, 0) 36.36%), linear-gradient(180deg, rgba(249, 250, 250, 0) 66.07%, #F9FAFA 88.42%), url('./hero.png') no-repeat -50% bottom; */
  /* background-blend-mode: normal, normal, multiply; */
}
@media screen and (max-width: 768px) {
  .hero {
    height: 514px;
  }
}
.hero h1 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 48px;
  line-height: 60px;
  /* or 125% */

  display: flex;
  align-items: center;
  letter-spacing: 0.01em;

  /* attis/primary */

  color: #04416d;
  max-width: 950px;
}
.hero h3 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 36px;
  line-height: 44px;
  /* or 122% */

  display: flex;
  align-items: center;

  /* attis/secondary */

  color: var(--color2);

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
  max-width: 480px;
}
.partners {
  padding: 60px 0;
  padding-top: 0;
}
.partners h5 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 36px;
  /* identical to box height, or 129% */

  /* attis/primary */

  color: #04416d;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
  margin-bottom: 24px;
}
.card {
  background: #ffffff;
  /* backdrop-filter: blur(20px); */
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 40px;

  /* Inside auto layout */

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  z-index: 1;
  box-shadow: none;
}
.homepage .card-body {
  padding: 40px !important;
  padding-bottom: 0;
}
.homepage .card-footer {
  padding: 40px !important;
  padding-top: 0px !important;
  background-color: transparent;
}
.homepage .card .card-body h5 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 36px;
  /* or 129% */

  /* attis/primary */

  color: #04416d;
}
.card .card-body ul {
  margin-left: 0;
  /* padding-inline: 1rem; */
}
.card .card-body li {
  padding-left: 10px;
  display: flex;
  margin-bottom: 5px;
}
.card .card-body ul {
  list-style: none; /* Remove default bullets */
}

.card .card-body ul li::before {
  content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
  font-size: 1.5em;
  color: #04416d; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */
  margin-right: 1em;
  margin-left: -2em; /* Also needed for space (tweak if needed) */
}
.card .card-body li,
.card .card-body p {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  /* neutral/30 */

  color: #797980;
}
.card .card-footer .prices-block {
  display: flex;
  flex-wrap: nowrap;
  align-items: end;
}
.card .card-footer .ordinary-price {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height, or 120% */

  /* neutral/30 */

  color: #797980;
}
.card .card-footer .privileged-price {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 24px;
  margin-left: 5px;
  /* identical to box height, or 117% */

  /* attis/primary */

  color: #04416d;
}
.card .card-footer .privileged-price small {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 24px;
  margin-left: 5px;
  /* identical to box height, or 150% */
  white-space: nowrap;

  letter-spacing: 0.1px;

  /* attis/primary */

  color: #04416d;
}
.card .card-footer .qty-block {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  letter-spacing: 0.25px;

  /* neutral/30 */

  color: #797980;
  margin-top: 10px;
}
.banner .banner-inner {
  margin: 60px 0;
  padding: 40px 44px;
  /* primary/primary */
  min-height: 348px;
  background-color: #fe5000;

  background-repeat: no-repeat;

  box-shadow:
    0px 30px 40px rgba(254, 80, 0, 0.16),
    0px 40px 60px rgba(254, 80, 0, 0.1);
  border-radius: 40px;
  position: relative;
}
.banner .banner-inner .banner-attis-bg {
  background-image: url("./atb_logo_banner.png");
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  border-radius: 40px;
  opacity: 0.1;
  background-repeat: no-repeat;
  background-position: bottom right;
}
.banner .banner-contents {
  z-index: 3;
  position: absolute;
  left: 40px;
  right: 40px;
  bottom: 40px;
  top: 40px;
}
.banner-top {
  align-items: center;
}
.banner-top img {
  display: block;
}
.banner-top > div > div {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 36px;
  /* or 129% */

  /* primary100 */
  margin-left: 15px;
  color: #ffffff;
}
.banner-middle {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  /* primary100 */

  color: #ffffff;
}
.btn-white.text-warning {
  color: #fe5000 !important;
  /* Title/Medium */

  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  letter-spacing: 0.1px;
}
.btn-white.text-warning i,
.btn-transparent i,
.btn-white.text-warning svg,
.btn-transparent svg {
  margin-left: 15px;
}
.contact-form-title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 44px;
  line-height: 56px;
  /* identical to box height, or 127% */

  display: flex;
  align-items: center;
  text-align: center;
  margin-top: 80px;
  justify-content: center;

  /* attis/primary */

  color: #04416d;
}
.form-group {
  position: relative;
  border: 1px solid #b1b1b1;
  border-radius: 4px;
  height: 56px;
  margin-top: 20px;
  margin-bottom: 36px;
}
.form-group.textarea {
  height: 112px;
}
.form-group .form-control {
  border: 0;
  height: 50px;
  position: absolute;
  box-shadow: none !important;
  outline: none !important;
}
.form-group textarea.form-control {
  height: 104px;
}
.form-group label {
  font-family: "Roboto";
  padding: 0 4px;
  background-color: #fff;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  position: absolute;
  left: 16px;
  z-index: 3;
  top: -8px;
  /* identical to box height, or 133% */

  /* neutral/30 */

  color: #797980;
}
.form-group.checkbox {
  border: 0;

  justify-content: flex-starts;
}
.form-group.checkbox input {
  position: relative;
  height: 24px;
  width: 24px;
  margin-right: 15px;
}
.form-group.checkbox label {
  position: relative;
  display: flex;
  left: 0;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  display: flex;
  align-items: start;

  /* neutral/10 */

  color: #333333;
}
.form-group.button {
  border: 0;
  margin-bottom: 80px;
}
.form-group.button button svg,
.form-group.button button i {
  margin-left: 15px;
}
footer {
  background-color: #333333;
}
footer .logo {
  width: 127px;
  height: 32px;
  background-image: url("data:image/svg+xml,%3Csvg width='127' height='32' viewBox='0 0 127 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.8967 0.010939L20.1256 2.85504V18.3869L13.8967 21.8816V0.010939ZM11.4421 24.2637V32L0.44433 26.0763L0 18.0909L11.4421 24.2637ZM11.3729 14.1568V21.9877L0.44433 15.7571V8.1739L11.3729 14.1568ZM24.6844 25.9572L13.8269 31.881V24.2038L24.6844 18.1849V25.9572ZM11.3018 11.859L4.383 8.30516L4.7099 3.02105L11.3018 0V11.859Z' fill='%23B1B1B1'/%3E%3Cpath d='M126.957 12.2588H122.689C122.611 11.7067 122.452 11.2163 122.212 10.7875C121.972 10.3523 121.663 9.9821 121.286 9.67681C120.91 9.37151 120.474 9.13767 119.981 8.97529C119.494 8.8129 118.964 8.7317 118.393 8.7317C117.36 8.7317 116.46 8.98828 115.694 9.50142C114.927 10.0081 114.333 10.7486 113.911 11.7229C113.488 12.6907 113.277 13.8664 113.277 15.25C113.277 16.6725 113.488 17.8677 113.911 18.8356C114.339 19.8034 114.937 20.5341 115.703 21.0278C116.47 21.5215 117.357 21.7683 118.363 21.7683C118.928 21.7683 119.451 21.6936 119.932 21.5442C120.419 21.3948 120.851 21.1772 121.228 20.8914C121.605 20.5991 121.916 20.2451 122.163 19.8294C122.417 19.4137 122.592 18.9395 122.689 18.4068L126.957 18.4263C126.847 19.3422 126.57 20.2256 126.129 21.0765C125.694 21.9209 125.106 22.6777 124.365 23.3467C123.631 24.0093 122.754 24.5354 121.735 24.9251C120.721 25.3084 119.575 25.5 118.295 25.5C116.515 25.5 114.924 25.0973 113.521 24.2918C112.124 23.4864 111.02 22.3204 110.208 20.794C109.403 19.2675 109 17.4195 109 15.25C109 13.074 109.409 11.2227 110.228 9.69629C111.046 8.16983 112.157 7.00713 113.56 6.20818C114.963 5.40273 116.541 5 118.295 5C119.451 5 120.523 5.16239 121.51 5.48717C122.504 5.81195 123.384 6.28612 124.151 6.9097C124.917 7.52677 125.541 8.28351 126.022 9.1799C126.509 10.0763 126.821 11.1026 126.957 12.2588Z' fill='%23B1B1B1'/%3E%3Cpath d='M64.4479 9.71641H70.3689V6H53.9469V9.71641H59.7297V26H64.4479V9.71641Z' fill='%23B1B1B1'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M42.2784 22.26H48.801L49.946 25.9994H55.1039L47.7716 6.00064H43.2965L36.0339 25.9994H41.1221L42.2784 22.26ZM43.4235 18.5436H47.6561L45.5282 11.6036L43.4235 18.5436Z' fill='%23B1B1B1'/%3E%3Cpath d='M88.0972 9.71641H82.1763V26H77.4235V9.71641H71.6408V6H88.0972V9.71641Z' fill='%23B1B1B1'/%3E%3Cpath d='M90 6H94.2188V18.5781H94.3848L103.027 6H106.729V26H102.5V13.4121H102.354L93.6621 26H90V6Z' fill='%23B1B1B1'/%3E%3C/svg%3E");
}
footer .nav-link {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  letter-spacing: 0.1px;

  /* neutral/70 */

  color: #b1b1b1;
}
footer .copy-right-section {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  /* primary100 */
  margin-top: 34px;
  color: #ffffff;
}
footer .copy-right-section a {
  color: #b1b1b1;
}
footer {
  padding: 50px 0;
}
@media screen and (max-width: 768px) {
  .hero h1 {
    font-size: 28px;
    line-height: 40px;
  }
  .hero h3 {
    font-size: 26px;
    line-height: 34px;
  }
  .banner-top > .d-flex {
    display: block !important;
  }
  .partners > .container > .d-flex,
  .services > .container > .d-flex {
    display: block !important;
  }
  .partners img,
  .services img,
  .banner-top img {
    max-width: 100%;
  }
  .banner-top > div > div {
    font-size: 18px;
    margin-left: 0;
    line-height: 24px;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  .banner .banner-contents {
    position: relative;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
  }
  .contact-form .card-body {
    padding: 10px;
  }
  .card .card-footer .prices-block,
  .card .card-footer .prices-block span {
    display: block;
  }

  footer .d-flex.align-items-center {
    display: block !important;
  }
  footer .d-flex.align-items-center .ml-auto {
    margin-left: 0 !important;
  }
  footer .copy-right-section {
    flex-direction: column-reverse;
  }
  footer .copy-right-section > div:nth-child(2) {
    margin-bottom: 15px;
  }
  .right-20 {
    right: 20px;
  }
  .top-20 {
    top: 20px;
  }
  .partners > .container > .d-flex > div {
    text-align: center !important;
    margin-block: 30px;
  }
  .partners > .container h5 {
    text-align: center;
  }
  .partners img {
    width: 60%;
  }
  .services .card {
    margin-bottom: 20px;
  }
  .banner-contents .btn.btn-white {
    white-space: nowrap;
    margin-top: 40px;
  }
  .contact-form-title {
    font-size: 24px;
    margin-top: 20px;
  }
  .form-group.button {
    margin-bottom: 20px;
  }
}
.gap-20 {
  gap: 20px;
}
footer .copy-right-section a {
  text-decoration: underline;
  color: #fff;
}
.form-group input::-webkit-input-placeholder,
.form-group input:-ms-input-placeholder,
.form-group input::placeholder,
.form-group textarea::placeholder {
  color: #797980;
}
.flag {
  position: relative;
}
.flag-dd {
  position: absolute;
  left: 0px;
  top: 30px;
  background: #f9faf9;
  border-radius: 8px;
}
.flag-dd .dropdown-menu {
  background: #f9faf9;
  border-radius: 8px;
  border: 0;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);
  min-width: unset;
}
.ru-flag,
.en-flag,
.cn-flag {
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-position: center;
  margin-top: 16px;
}
.ru-flag,
.ru-flag-indicator {
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='20' viewBox='0 0 24 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cmask id='mask0_274_14427' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='0' y='0' width='24' height='20'%3E%3Crect width='24' height='20' rx='4' fill='%23D9D9D9'/%3E%3C/mask%3E%3Cg mask='url(%23mask0_274_14427)'%3E%3Crect y='13.3333' width='24' height='6.66667' fill='%23D80027'/%3E%3Crect y='6.66675' width='24' height='6.66667' fill='%230052B4'/%3E%3Crect width='24' height='6.66667' fill='%23F0F0F0'/%3E%3C/g%3E%3C/svg%3E") !important;
}
.en-flag,
.en-flag-indicator {
  margin-top: 0;
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='20' viewBox='0 0 24 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_274_14433)'%3E%3Crect width='24' height='20' rx='4' fill='white'/%3E%3Cg clip-path='url(%23clip1_274_14433)'%3E%3Cpath d='M12 28C21.9411 28 30 19.9411 30 10C30 0.0588741 21.9411 -8 12 -8C2.05887 -8 -6 0.0588741 -6 10C-6 19.9411 2.05887 28 12 28Z' fill='%23F0F0F0'/%3E%3Cpath d='M-2.27906 -0.95874C-3.69298 0.880846 -4.75912 3.00112 -5.37991 5.30449H3.98416L-2.27906 -0.95874Z' fill='%230052B4'/%3E%3Cpath d='M29.3799 5.30454C28.7591 3.00124 27.6929 0.880968 26.2791 -0.958618L20.016 5.30454H29.3799Z' fill='%230052B4'/%3E%3Cpath d='M-5.37991 14.6958C-4.75905 16.9991 -3.69291 19.1194 -2.27906 20.9589L3.98395 14.6958H-5.37991Z' fill='%230052B4'/%3E%3Cpath d='M22.9588 -4.27896C21.1192 -5.69287 18.999 -6.75902 16.6956 -7.37988V1.98413L22.9588 -4.27896Z' fill='%230052B4'/%3E%3Cpath d='M1.04123 24.279C2.88082 25.6929 5.00109 26.7591 7.30439 27.3799V18.016L1.04123 24.279Z' fill='%230052B4'/%3E%3Cpath d='M7.30432 -7.37988C5.00102 -6.75902 2.88075 -5.69288 1.04123 -4.27903L7.30432 1.98405V-7.37988Z' fill='%230052B4'/%3E%3Cpath d='M16.6957 27.3799C18.999 26.7591 21.1192 25.6929 22.9588 24.2791L16.6957 18.016V27.3799Z' fill='%230052B4'/%3E%3Cpath d='M20.016 14.6958L26.2791 20.959C27.6929 19.1194 28.7591 16.9991 29.3799 14.6958H20.016Z' fill='%230052B4'/%3E%3Cpath d='M29.8476 7.65219H14.3479H14.3479V-7.84763C13.5793 -7.94769 12.7957 -8 12 -8C11.2041 -8 10.4207 -7.94769 9.65219 -7.84763V7.65205V7.65213H-5.84763C-5.94769 8.42071 -6 9.20427 -6 10C-6 10.7959 -5.94769 11.5793 -5.84763 12.3478H9.65205H9.65213V27.8476C10.4207 27.9477 11.2041 28 12 28C12.7957 28 13.5793 27.9478 14.3478 27.8476V12.3479V12.3479H29.8476C29.9477 11.5793 30 10.7959 30 10C30 9.20427 29.9477 8.42071 29.8476 7.65219Z' fill='%23D80027'/%3E%3Cpath d='M16.6957 14.6957L24.7279 22.728C25.0973 22.3587 25.4497 21.9726 25.786 21.5724L18.9093 14.6957H16.6957V14.6957Z' fill='%23D80027'/%3E%3Cpath d='M7.30432 14.6958H7.30418L-0.727966 22.728C-0.358685 23.0974 0.0274006 23.4498 0.427619 23.786L7.30432 16.9092V14.6958Z' fill='%23D80027'/%3E%3Cpath d='M7.30433 5.3044V5.30426L-0.727887 -2.72803C-1.09731 -2.35875 -1.44972 -1.97266 -1.78595 -1.57244L5.09082 5.30433H7.30433V5.3044Z' fill='%23D80027'/%3E%3Cpath d='M16.6957 5.30446L24.728 -2.7279C24.3587 -3.09732 23.9726 -3.44972 23.5724 -3.78589L16.6957 3.09089V5.30446Z' fill='%23D80027'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_274_14433'%3E%3Crect width='24' height='20' rx='4' fill='white'/%3E%3C/clipPath%3E%3CclipPath id='clip1_274_14433'%3E%3Crect width='36' height='36' fill='white' transform='translate(-6 -8)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E") !important;
}
.cn-flag,
.cn-flag-indicator {
  margin-bottom: 0;
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='20' viewBox='0 0 24 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_274_14432)'%3E%3Crect width='24' height='20' rx='4' fill='white'/%3E%3Cg clip-path='url(%23clip1_274_14432)'%3E%3Crect width='32' height='32' transform='translate(-2 -6)' fill='%23D80027'/%3E%3Cpath d='M14 26C22.8366 26 30 18.8366 30 10C30 1.16344 22.8366 -6 14 -6C5.16344 -6 -2 1.16344 -2 10C-2 18.8366 5.16344 26 14 26Z' fill='%23D80027'/%3E%3Cpath d='M6.75625 3.73755L8.1375 7.98755H12.6062L8.99375 10.6188L10.375 14.8688L6.75625 12.2438L3.1375 14.8688L4.525 10.6188L0.90625 7.98755H5.375L6.75625 3.73755Z' fill='%23FFDA44'/%3E%3Cpath d='M16.9688 18.7813L15.9125 17.4813L14.35 18.0875L15.2563 16.6813L14.2 15.375L15.8188 15.8063L16.7313 14.4L16.8188 16.075L18.4438 16.5063L16.875 17.1063L16.9688 18.7813Z' fill='%23FFDA44'/%3E%3Cpath d='M19.0688 14.9688L19.5688 13.3688L18.2 12.4L19.875 12.375L20.3688 10.775L20.9125 12.3625L22.5875 12.3438L21.2438 13.3438L21.7813 14.9313L20.4125 13.9625L19.0688 14.9688Z' fill='%23FFDA44'/%3E%3Cpath d='M21.9 5.74382L21.1625 7.25007L22.3625 8.41882L20.7062 8.18132L19.9687 9.68132L19.6812 8.03132L18.0187 7.79382L19.5062 7.01257L19.2187 5.35632L20.4187 6.52507L21.9 5.74382Z' fill='%23FFDA44'/%3E%3Cpath d='M17.0125 1.18127L16.8875 2.85003L18.4437 3.48128L16.8125 3.88128L16.6937 5.55627L15.8125 4.13128L14.1812 4.53127L15.2625 3.25002L14.375 1.83127L15.9312 2.46252L17.0125 1.18127Z' fill='%23FFDA44'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_274_14432'%3E%3Crect width='24' height='20' rx='4' fill='white'/%3E%3C/clipPath%3E%3CclipPath id='clip1_274_14432'%3E%3Crect width='32' height='32' fill='white' transform='translate(-2 -6)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E") !important;
}
.ru-flag-indicator,
.en-flag-indicator,
.cn-flag-indicator {
  width: 24px !important;
  height: 24px !important;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% !important;
  margin-top: -3px;
}
.nav-item.login {
  margin-left: 40px;
}
.nav-item.register {
  margin-left: 24px;
}
.nav-item.register .btn-primary {
  padding-left: 16px;
  padding-right: 16px;
  font-weight: 500;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  display: flex;
  align-items: center;
  letter-spacing: 0.1px;
  transition: none !important;
  background: linear-gradient(90deg, var(--color1) 0%, var(--color2) 100%);
}
.nav-item.register .btn-primary:hover {
  background: var(--color2) !important;
  box-shadow: none !important;
  color: #fff !important;
}
.nav-item.login .nav-link:hover {
  color: #333333 !important;
}
</style>
<style>
.homepage .card-body .description ul {
  list-style: none;
  padding-left: 0;
}
.homepage .card-body .description ul li {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 5px;
}
.homepage .card-body .description ul li:before {
  content: "";
  width: 6px;
  flex-basis: 6px;
  min-width: 6px;
  max-width: 6px;
  height: 6px;
  margin-top: 10px;

  /* attis/primary */

  background: #04416d;
  border-radius: 3px;
  display: block;
}
.home-banner-title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 36px;
  /* or 129% */

  /* primary100 */

  color: #ffffff;
}
.banner-middle.home-banner-middle {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
  /* or 117% */

  /* primary100 */

  color: #ffffff;
}
.domestic-slider {
  overflow: hidden;
  padding: 20px 0;
}
.domestic-slider-injet {
  transition: all 1s;
}
.slide-indicator {
  width: 16px;
  height: 16px;
  border-radius: 16px;
  background: #ffffff;
  transition: all 1s;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04) !important;
  cursor: pointer;
}
.slide-indicator.active {
  width: 48px;
  background-color: #47b2e44f;
  cursor: default;
}
.domestic-slider-dots {
  display: flex;
  justify-content: center;
  gap: 10px;
}
.domestic-slider-arrows {
  position: absolute;
  width: 100%;
  display: flex;
  align-items: space-between;
  justify-content: space-between;
  top: 50%;
  transform: translate(-50%);
  max-width: 1260px;
  left: 50%;
  z-index: 0;
}
.domestic-slider-arrows .larr,
.domestic-slider-arrows .rarr {
  cursor: pointer;
  background: #ffffff;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04) !important;
}
@media screen and (max-width: 768px) {
  .domestic-slider-arrows,
  .domestic-slider-dots {
    display: none;
  }
}
.position-relative {
  position: relative;
}
.header-bg{
  height: 72px;
  border-radius: 0px 0px 20px 20px;
  background: #FFF;
  box-shadow: 0px 4px 60px 0px rgba(0, 38, 66, 0.10);
}
.header-bg.is_sticky{
  position: sticky !important;
  top: 0;
}
</style>
